import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {StyleableTextComponent} from './styleable-text.component';

@NgModule({
  imports: StyleableTextModule.IMPORTS,
  declarations: StyleableTextModule.DECLARATIONS,
  exports: StyleableTextModule.DECLARATIONS
})
export class StyleableTextModule {
  public static readonly IMPORTS = [CommonModule];

  public static readonly DECLARATIONS = [StyleableTextComponent];
}
